import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=4b1f2dcd&scoped=true"
import script from "./ButtonAction.js?vue&type=script&lang=js&external"
export * from "./ButtonAction.js?vue&type=script&lang=js&external"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=4b1f2dcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f2dcd",
  null
  
)

export default component.exports